export default {
    label: "Tarefas",
    page_title: "Tarefas",
    list_subtitle: "Lista de tarefas",
    filter: "Filtro",
    close: "Fechar",
    description: "Descrição",
    description_placeholder: "Adicione uma descrição detalhada...",
    title_placeholder: "Nome da tarefa...",
    automation_prefix: "Automação: ",
    created_by: "Tarefa criada por: {0}",
    created_by_automation: "Tarefa criada por: automação {0}",
    created_by_label: "Criado por",
    automation_source: "automação {0}",
    form_response: "Resposta do formulário",
    col_name: "Nome",
    col_board: "Quadro",
    col_stage: "Etapa",
    col_assignee: "Responsável",
    col_client: "Cliente",
    col_group: "Quadro",
    col_status: "Status",
    col_due_date: "Vencimento",
    col_priority: "Prioridade",
    no_date: "Sem data",
    complete: "Concluir",
    reopen: "Reabrir",
    status_pending: "Pendente",
    status_in_progress: "Em andamento",
    status_completed: "Concluída",
    status_archived: "Arquivada",
    priority_normal: "Média",
    add: "Adicionar",
    add_new_task: "Adicionar nova tarefa",
    add_task_short: "Adicionar",
    batch_actions: "Ações em lote",
    batch_actions_short: "Ações",
    change_deadline: "Alterar Prazo",
    change_deadline_batch: "Alterar prazo em lote",
    export: "Exportar",
    export_tasks: "Exportar tarefas",
    archive: "Arquivar",
    mark_as_completed: "Marcar como concluída",
    tasks_count: "{0} tarefas",
    tasks_count_of_total: "{0} de {1}",
    no_tasks_found: "Nenhuma tarefa encontrada!",
    archived_badge: "Arquivada",
    completed_badge: "Concluída",
    back: "Voltar",
    task_archived_status: "Tarefa arquivada",
    task_already_completed: "Tarefa já concluída",

    confirm_archive_batch_title: "Tem certeza que deseja arquivar {0} tarefas?",
    confirm_archive_batch_body: "Essa ação irá arquivar todas as tarefas correspondentes ao filtro atual.",
    confirm_complete_all_title: "Tem certeza que deseja marcar {0} tarefas como concluídas?",
    confirm_complete_all_body: "Essa ação irá marcar como feitas todas as tarefas correspondentes ao filtro atual.",
    confirm_batch_deadline_body: "Essa ação irá alterar o prazo de todas as tarefas do filtro atual para a data abaixo.",
    new_deadline: "Novo prazo",
    confirm_complete_task_title_before: "Tem certeza que deseja marcar a tarefa",
    confirm_complete_task_title_after: "como concluída?",
    confirm_complete_task_body: "Essa tarefa será marcada como concluída após a confirmação.",
    confirm_archive_task_title_archive: "Tem certeza que deseja arquivar a tarefa",
    confirm_archive_task_title_restore: "Tem certeza que deseja restaurar a tarefa",
    confirm_archive_task_body_archived: "Essa tarefa será arquivada após a confirmação.",
    confirm_archive_task_body_restored: "Essa tarefa será restaurada após a confirmação.",
    confirm_delete_note_title: "Tem certeza que deseja excluir este comentário?",
    confirm_delete_note_body: "Esta ação não pode ser desfeita.",

    priority: "Prioridade",
    task_priority: "Prioridade da tarefa",
    priority_undefined: "Indefinida",
    priority_low: "Baixa",
    priority_medium: "Média",
    priority_high: "Alta",
    deadline: "Prazo",
    not_defined: "Não definido",
    assignee: "Responsável",
    requester: "Solicitante",
    task_assignee: "Responsável pela tarefa",
    client: "Cliente",
    integration_id: "Id Integração:",
    view_profile: "Ver perfil",
    order: "Venda",
    quotation: "Orçamento",
    view_on_client: "Ver no cliente",
    feedback: "Resposta",
    linked_answer: "Resposta vinculada",
    linked_answer_placeholder: "Selecione uma resposta",
    linked_answer_none: "Nenhuma",
    linked_answer_help: "Vincule uma resposta do cliente a esta tarefa.",
    linked_answer_need_client: "Selecione um cliente para vincular uma resposta.",
    open_answer: "Abrir resposta",
    average: "Média:",
    attachments_title: "Anexos",
    attachments_empty: "Nenhum arquivo anexado",
    attachments_upload: "Adicionar arquivos",
    attachments_uploading: "Enviando...",
    attachments_delete: "Remover anexo",
    notify_file_uploaded: "Arquivo(s) anexado(s)",
    notify_file_upload_error: "Não foi possível anexar o arquivo",
    notify_file_deleted: "Anexo removido",
    notify_file_delete_error: "Não foi possível remover o anexo",
    notify_answer_linked: "Resposta vinculada",
    notify_answer_link_error: "Não foi possível vincular a resposta",
    board: "Quadro",
    task_board: "Quadro da tarefa",
    none: "Nenhum",
    automation: "Automação",
    creation_date: "Data de criação",
    completed_at: "Concluída em",

    client_not_subscribed_whatsapp: "O cliente não permitiu o recebimento de mensagens por WhatsApp.",
    suggested_message: "Mensagem sugerida:",
    send_via_whatsapp: "Enviar por WhatsApp",
    send_via_email: "Enviar por E-mail",

    notes_title: "Comentários",
    note_placeholder: "Escreva aqui o que você fez ou pretende fazer em relação a essa tarefa",
    add_note: "Comentar",
    save: "Salvar",
    cancel: "Cancelar",
    edit_note: "Editar comentário",
    delete_note: "Excluir comentário",
    edit_note_text: "Editar texto do comentário",
    new_note: "Novo comentário",
    edit_task: "Editar tarefa",
    archive_task: "Arquivar tarefa",

    notify_task_completed: "Tarefa concluída!",
    notify_task_reopened: "Tarefa reaberta!",
    notify_error_update: "Erro ao atualizar tarefa",
    notify_task_archived: "Tarefa arquivada!",
    notify_task_unarchived: "Tarefa desarquivada!",
    notify_tasks_archived: "{0} tarefas arquivadas!",
    notify_tasks_completed: "{0} tarefas concluídas!",
    notify_deadlines_updated: "{0} prazos atualizados!",
    notify_note_saved: "Comentário salvo com sucesso",
    notify_note_updated: "Comentário atualizado com sucesso",
    notify_note_deleted: "Comentário excluído com sucesso",
    notify_note_empty: "O comentário não pode estar vazio",
    notify_error_update_note: "Erro ao atualizar comentário",
    notify_error_delete_note: "Erro ao excluir comentário",
    notify_error_load_more: "Erro ao carregar mais tarefas",
    notify_error_load: "Erro ao carregar tarefas",
    notify_task_saved: "Tarefa salva com sucesso",

    filter_automation: "Automação",
    filter_status: "Situação",
    filter_status_pending: "Pendentes",
    filter_status_completed: "Completas",
    filter_status_archived: "Arquivadas",
    filter_assignee: "Responsável",
    filter_task_due_date: "Prazo da tarefa",
    filter_creation_date: "Data de criação",
    filter_tags: "Tag",
    notify_tag_error: "Não foi possível atualizar a tag",

    form: {
        title_label: "Título",
        assignee: "Responsável",
        deadline: "Prazo",
        client: "Cliente",
        description: "Descrição",
        suggested_message: "Sugestão de mensagem",
        cancel: "Cancelar",
        save: "Salvar",
        days: "Dom,Seg,Ter,Qua,Qui,Sex,Sab",
        months: "Jan,Fev,Mar,Abr,Mai,Jun,Jul,Ago,Set,Out,Nov,Dez",
        apply: "Aplicar",
    },

    select_board: "Selecionar quadro",
    create_board: "Criar quadro",
    create_board_action: "Criar",
    board_name_placeholder: "Nome do quadro",
    switch_to_board: "Ver em quadro",
    switch_to_list: "Ver em lista",
    create_task_title: "Nova tarefa",
    create_more: "Criar mais",
    create_task_stage_placeholder: "Estágio",
    create_task_title_required: "Informe o título da tarefa",
    create_task_action: "Criar tarefa",
    no_boards: "Nenhum quadro encontrado",
    no_board_option: "Nenhum quadro",
    delete_board: "Excluir quadro",

    boards: {
        board_title: "Quadro:",
        task_details: "Detalhes da tarefa",
        add_task_placeholder: "Adicionar tarefa...",
        complete_column: "Concluir",
        complete_drop_hint: "Solte aqui para concluir",
        empty_column: "Nenhuma tarefa",
        new_column: "Nova coluna",
        confirm_archive_board_title_before: "Tem certeza que deseja arquivar o quadro",
        confirm_archive_board_body: "Esse quadro será arquivado após a confirmação.",
        new_board_placeholder: "Novo quadro...",
        notify_board_archived: "Quadro arquivado com sucesso!",
        notify_board_created: "Quadro criado com sucesso!",
        quotation_total: "Orçamentos (total):",
        quotation_drafts: "Rascunhos:",
        quotation_sent: "Enviados:",
        quotation_accepted: "Aprovados:",
        quotation_rejected: "Recusados:",
        quotation_expired: "Expirados:",
    },
};
